"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientPricingPlan = void 0;
var ClientPricingPlan;
(function (ClientPricingPlan) {
    ClientPricingPlan["STARTER"] = "starter";
    ClientPricingPlan["STANDARD"] = "standard";
    ClientPricingPlan["PRO"] = "pro";
    ClientPricingPlan["CUSTOM"] = "custom";
})(ClientPricingPlan || (exports.ClientPricingPlan = ClientPricingPlan = {}));
